<div class="my-container">
  <div class="my-breadcrumbs">
    <nz-breadcrumb>
      @for (breadcrumb of breadcrumbs; track breadcrumb) {
      <nz-breadcrumb-item>{{ breadcrumb.label }}</nz-breadcrumb-item>
      }
    </nz-breadcrumb>
  </div>
  <div class="my-title">{{ title }}</div>
  @if (!someError) {
  <div class="my-body">
    <div class="my-search">
      <form [formGroup]="formBusqueda" class="tw-flex">
        <nz-input-group>
          <input nz-input type="text" formControlName="busqueda" placeholder="Buscar..." />
        </nz-input-group>
        @if (showSearchButton) {
        <button nz-button nzType="primary" type="button" (click)="callFilter.emit(formBusqueda.controls.busqueda.value)"><i class="fas fa-search"></i> Buscar</button>
        }
        <span nzInputSuffix>
          @if (formBusqueda.controls.busqueda.value) {
          <button type="button" nz-button nzType="link" aria-label="Limpiar búsqueda" class="tw-mr-3" (click)="formBusqueda.controls.busqueda.setValue('')">
            <i class="fal fa-close"></i>
          </button>
          }
          <i class="fal fa-search"></i>
        </span>
      </form>
    </div>
    <div class="my-table">
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      <nz-table #basicTable [nzData]="sortData" [nzLoading]="loading" [nzFrontPagination]="!customPagination" [nzShowPagination]="true" (nzQueryParams)="sort($event)">
        <thead nzSingleSort>
          <tr>
            @for (item of header; track trackByHeader($index, item)) {
            <th
              scope="col"
              class="tw-font-semibold"
              [nzSortFn]="item.sort"
              [nzColumnKey]="item.key"
              [nzShowSort]="item.sort"
              [nzSortOrder]="sortValue.key === item.key ? sortValue.value : null"
              [class]="item.class"
            >
              {{ item.label }}
            </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of basicTable.data; track trackByRow($index, row)) {
          <tr nz-tooltip nzTooltipTitle="Doble clic para editar" nzTooltipPlacement="topLeft" class="tw-cursor-pointer" (dblclick)="onDbClick(row)">
            <ng-container *ngTemplateOutlet="rowTemplate; context: { row: row }"></ng-container>
          </tr>
          }
        </tbody>
      </nz-table>
      <div class="tw-flex tw-justify-end tw-mt-2">
        @if (totalData > 0) {
        <span>
          <span class="general-table-total">Total: {{ totalData }} elementos</span>
          <nz-pagination
            #paginationComponent
            (nzPageIndexChange)="onChangePage($event)"
            [nzPageIndex]="pageIndex ? pageIndex : basicTable.nzPageIndex"
            [nzTotal]="totalData"
            [nzPageSize]="pageSize"
            [nzPageSizeOptions]="[5, 15, 20, 50]"
            [nzShowSizeChanger]="customPagination"
            (nzPageSizeChange)="onChangePageSize($event)"
          ></nz-pagination>
          <button type="button" aria-label="Actualizar" class="tw-ml-2" nz-button [disabled]="loading" (click)="onUpdateData()"><i class="fa-solid fa-arrows-rotate"></i></button>
        </span>
        }
      </div>
    </div>
  </div>
  } @if (someError) {
  <div class="my-body">
    @if (someError) {
    <nz-alert
      class="tw-mb-1"
      nzType="error"
      [nzMessage]="'No pudimos obtener la información de la lista de ' + title"
      nzDescription="Pruebe a recargar la página e inténtelo de nuevo. Si el problema persiste no dude en contactar con nosotros"
    ></nz-alert>
    }
  </div>
  }
</div>
